export default __webpack_public_path__ + "static/media/grafema_ciceco_07.a050f7cb.jpg";